// Image Slider Section with Swiper.js
document.addEventListener('DOMContentLoaded', function() {
  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper.js not loaded. Falling back to basic display.');
    // Fallback: show all images in a grid
    const imageSliders = document.querySelectorAll('.image-slider-swiper');
    imageSliders.forEach(function(swiperElement) {
      swiperElement.style.display = 'grid';
      swiperElement.style.gridTemplateColumns = 'repeat(auto-fit, minmax(300px, 1fr))';
      swiperElement.style.gap = '32px';
      swiperElement.querySelector('.swiper-wrapper').style.display = 'contents';
      swiperElement.querySelectorAll('.swiper-slide').forEach(function(slide) {
        slide.style.width = 'auto';
        slide.style.height = 'auto';
      });
    });
    return;
  }

  // Initialize all image slider swipers
  const imageSliders = document.querySelectorAll('.image-slider-swiper');
  
  imageSliders.forEach(function(swiperElement) {
    const section = swiperElement.closest('.section');
    const autoplayValue = section.getAttribute('data-autoplay');
    const autoplaySpeedValue = section.getAttribute('data-speed');
    
    const autoplayDelay = autoplaySpeedValue ? parseInt(autoplaySpeedValue) * 1000 : 5000;
    const enableAutoplay = autoplayValue === 'true';
    
    const swiper = new Swiper(swiperElement, {
      // Basic settings
      slidesPerView: 1,
      spaceBetween: 32,
      loop: false,
      
      // Responsive breakpoints
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        }
      },
      
      // Pagination progress
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        clickable: true,
      },
      
      // No navigation arrows
      navigation: false,
      
      // Autoplay
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      
      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous image',
        nextSlideMessage: 'Next image',
        firstSlideMessage: 'This is the first image',
        lastSlideMessage: 'This is the last image',
        paginationBulletMessage: 'Go to image {{index}}',
      },
      
      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      
      // Touch/swipe support
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      
      // Performance
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      
      // Events
      on: {
        init: function() {
          // Add ARIA labels for accessibility
          this.slides.forEach((slide, index) => {
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-roledescription', 'image');
            slide.setAttribute('aria-label', `${index + 1} of ${this.slides.length}`);
          });
        },
        
        slideChange: function() {
          // Update ARIA labels on slide change
          this.slides.forEach((slide, index) => {
            slide.setAttribute('aria-label', `${index + 1} of ${this.slides.length}`);
          });
        }
      }
    });
    
    // Pause autoplay on hover
    if (enableAutoplay) {
      swiperElement.addEventListener('mouseenter', function() {
        swiper.autoplay.stop();
      });
      
      swiperElement.addEventListener('mouseleave', function() {
        swiper.autoplay.start();
      });
    }
  });
});

// Handle theme editor changes
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    // Reinitialize swipers when sections are loaded in theme editor
    const imageSliders = event.target.querySelectorAll('.image-slider-swiper');
    imageSliders.forEach(function(swiperElement) {
      if (swiperElement.swiper) {
        swiperElement.swiper.destroy(true, true);
      }
    });
    
    // Reinitialize after a short delay
    setTimeout(function() {
      const imageSliders = event.target.querySelectorAll('.image-slider-swiper');
      imageSliders.forEach(function(swiperElement) {
        const section = swiperElement.closest('.section');
        const autoplayValue = section.getAttribute('data-autoplay');
        const autoplaySpeedValue = section.getAttribute('data-speed');
        
        const autoplayDelay = autoplaySpeedValue ? parseInt(autoplaySpeedValue) * 1000 : 5000;
        const enableAutoplay = autoplayValue === 'true';
        
        new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 32,
          breakpoints: {
            768: { slidesPerView: 2, spaceBetween: 32 },
            1024: { slidesPerView: 3, spaceBetween: 32 }
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
            clickable: true,
          },
          navigation: false,
          autoplay: enableAutoplay ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          } : false,
          keyboard: { enabled: true, onlyInViewport: true },
          touchRatio: 1,
          grabCursor: true,
        });
      });
    }, 100);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    // Destroy swipers when sections are unloaded
    const imageSliders = event.target.querySelectorAll('.image-slider-swiper');
    imageSliders.forEach(function(swiperElement) {
      if (swiperElement.swiper) {
        swiperElement.swiper.destroy(true, true);
      }
    });
  });
}
